export default class DrawflowHelpers {
	static childRecordsAttributeKey = {
		measure: "articles_measures_attributes",
		measure_with_options: "measure_options_attributes",
		property: "actors_properties_attributes",
	};

	static saveToRails(drawflowInstance) {
		pp.log("Drawflow Helpers saveToRails", drawflowInstance);

		if (Object.keys(drawflowInstance.deletedNodes).length) {
			const deletionParams = [];
			Object.values(drawflowInstance.deletedNodes).forEach(
				(deletedNodesData) => {
					Object.entries(deletedNodesData).forEach(
						([deletedNodeId, deletedNodeData]) => {
							pp.log("- at", deletedNodeId, deletedNodeData);
							if (deletedNodeData.parent_node) {
								const parentNode = drawflowInstance.getNodeFromId(
									deletedNodeData.parent_node,
									true,
								);
								if (!parentNode) {
									return; // Assume that the parentNode has been deleted as well, so this child will get deleted along with the parent
								}
								const childRecordsAttr =
									this.childRecordsAttributeKey[parentNode.html];
								const parentNodeData = { id: parentNode.data.id };
								parentNodeData[childRecordsAttr] =
									parentNodeData[childRecordsAttr] || [];
								parentNodeData[childRecordsAttr].push({
									id: deletedNodeId,
									_destroy: true,
								});
								deletionParams.push(parentNodeData);
							} else {
								deletionParams.push({ id: deletedNodeId, _destroy: true });
							}
						},
					);
				},
			);
			pp.log("- got deletionParams", deletionParams);
			this.sendDataToRails(
				drawflowInstance,
				deletionParams,
				(data, status, response) => {
					drawflowInstance.deletedNodes = {};
				},
			);
		}

		const topNodes = Object.values(
			drawflowInstance.drawflow.drawflow[drawflowInstance.module].data,
		).filter((el) => {
			return !el.data.child_of;
		});
		const params = topNodes.map((topNode) => {
			return this.parameterizeNode(drawflowInstance, topNode);
		});

		pp.log("Drawflow Helpers saveToRails", drawflowInstance, params);
		if (!Object.keys(params).length) {
			return; // Nothing to save
		}
		this.sendDataToRails(drawflowInstance, params, (data, status, response) => {
			// drawflowInstance.deletedNodes = {};
		});
	}

	static sendDataToRails(drawflowInstance, params, successCallback) {
		$.ajax({
			url: `/games/${drawflowInstance.gameId}/${drawflowInstance.module}/update_batched`,
			type: "POST",
			data: { records_attributes: params },
			dataType: "json",
			success: successCallback,
			error: (jsXHR, textStatus) => {
				console.error("Could not save to Rails", jsXHR, textStatus);
				pp.notifications.display("error", jsXHR.responseJSON.errors);
			},
		});
	}

	static parameterizeNode(drawflowInstance, node, forceFakeId) {
		// pp.log("Drawflow Helpers parameterizeNode", node, this);

		let params = {};
		params[node.data.id && !forceFakeId ? "id" : "fake_id"] =
			node.data.id || node.id;

		switch (node.html) {
			case "measure":
				Object.assign(params, {
					clone_of: node.data.clone_of,
					names: { 0: { key: I18n.locale, value: node.data.measure_name } },
				});

				break;

			case "measure_with_options":
				Object.assign(params, {
					clone_of: node.data.clone_of,
					names: { 0: { key: I18n.locale, value: node.data.measure_name } },
				});
				break;

			case "article_measure":
				Object.assign(params, { article_id: node.data.article_id });
				params.downstream_article_measure_links_attributes = Object.values(
					node.outputs,
				)[0].connections.map((connectionItem) => {
					const downstreamNode = drawflowInstance.getNodeFromId(
						connectionItem.node,
					);
					const params = {
						id: connectionItem.id,
						edge_type: connectionItem.output,
					};
					params[
						downstreamNode.data.id
							? "downstream_article_measure_id"
							: "fake_downstream_article_measure_id"
					] = downstreamNode.data.id || downstreamNode.id;
					return params;
				});
				break;

			case "property":
				Object.assign(params, {
					calculation_id: node.data.calculation_id,
					set_type_key_from_name: node.data.set_type_key_from_name || false,
					clone_of: node.data.clone_of,
					names: { 0: { key: I18n.locale, value: node.data.property_name } },
				});
				break;

			case "actor_property":
				Object.assign(params, {
					actor_id: node.data.actor_id,
					base_value: node.data.base_value,
				});
				params.downstream_actor_property_links_attributes = Object.values(
					node.outputs,
				)[0].connections.map((connectionItem) => {
					const downstreamNode = drawflowInstance.getNodeFromId(
						connectionItem.node,
					);
					const params = {
						id: connectionItem.id,
						connection_name: connectionItem.output,
					};
					params[
						downstreamNode.data.id
							? "downstream_actor_property_id"
							: "fake_downstream_actor_property_id"
					] = downstreamNode.data.id || downstreamNode.id;
					return params;
				});
				break;

			default:
				console.error("Don't know how to handle node:", node);
		}

		const childRecordsAttr =
			DrawflowHelpers.childRecordsAttributeKey[node.html];
		params[childRecordsAttr] = [];
		if (node.child_nodes && Object.keys(node.child_nodes).length) {
			params[childRecordsAttr].push(
				...Object.keys(node.child_nodes).map((childId) => {
					const childNode = drawflowInstance.getNodeFromId(childId);
					return this.parameterizeNode(
						drawflowInstance,
						childNode,
						forceFakeId,
					);
				}),
			);
		}
		return params;
	}

	static addToDagre(drawflowInstance, node, domEl) {
		// pp.log("into addToDagre", node, domEl);
		// pp.log("- width, height", domEl.offsetWidth, domEl.offsetHeight);
		drawflowInstance.dagreGraph.setNode(
			node.id,
			{ label: "", width: domEl.offsetWidth, height: domEl.offsetHeight }, // `label` does not seem to do anything
		);
		this.setEdgesForDagre(drawflowInstance.dagreGraph, node.id, node);
	}

	static setEdgesForDagre(dagreGraph, topMostNodeId, currentNode) {
		// pp.log("into setEdgesForDagre", topMostNodeId, currentNode);
		if (currentNode.child_nodes) {
			Object.values(currentNode.child_nodes).forEach((childNode) => {
				this.setEdgesForDagre(dagreGraph, topMostNodeId, childNode);
			});
		} else if (currentNode.inputs) {
			for (let inputName in currentNode.inputs) {
				for (let connectionItem in currentNode.inputs[inputName].connections) {
					Object.values(currentNode.inputs[inputName].connections).forEach(
						(sourceNode) => {
							dagreGraph.setEdge(
								sourceNode.upstream_identifier || sourceNode.node,
								topMostNodeId,
								{ label: "" },
							); // `label` does not seem to do anything
						},
					);
				}
			}
		}
	}

	static positionNode(vueInstance) {
		// pp.log("Drawflow Helpers into positionNode", vueInstance.dataNode.id);
		const ownPosData = vueInstance.drawflowInstance.dagreGraph.node(
			vueInstance.dataNode.id,
		);
		const domEl = vueInstance.$el.closest(".container-node");
		// pp.log("- setting", domEl, ownPosData);
		domEl.style.left = `${ownPosData.x}px`;
		domEl.style.top = `${ownPosData.y}px`;
		pp.vue.bus.$emit("DRAWFLOW-node-moved", {
			nodeId: vueInstance.dataNode.id,
		});
	}

	//-------------------------------------------------------------------

	constructor(vueInstance) {
		// pp.log("into DrawflowHelpers", vueInstance);
		this.vueInstance = vueInstance;
		this.drawflowInstance = vueInstance.drawflowInstance;

		if (this.vueInstance.dataNode.pendingLoadEditForm) {
			setTimeout(() => {
				this._loadEditForm();
			}, 100);
		}

		if (this.vueInstance.dataNode.data.old_fake_id) {
			pp.log("- dynamic insertion of", this.vueInstance.dataNode.id);
			setTimeout(() => {
				this.connectNode("inputs");
				this.connectNode("outputs");
				delete this.vueInstance.dataNode.data.old_fake_id;
			}, 50);
		}

		this.drawflowInstance.on("beforeNodeRemoved", (nodeId) => {
			// NB not having an `$el` means that this helper's vueInstance has been destroyed by it's parents
			if (this.vueInstance.$el && nodeId == this.vueInstance.dataNode.id) {
				pp.log(
					"Drawflow Helpers into beforeNodeRemoved",
					this.vueInstance.dataNode.id,
				);
				this._nodeRemoved();
			}
		});
	}

	duplicateNode() {
		// pp.log("into duplicateNode", this.vueInstance);
		const nodeId = this.vueInstance.dataNode.id;
		const origNode = this.drawflowInstance.getNodeFromId(nodeId);
		pp.log("into duplicateNode", nodeId, origNode);
		const clone = structuredClone(origNode);
		clone.id = `m-${pp.viewHelpers.generateRandomId()}`;
		// This will be overwritten below if the node is a `child_of`
		clone.pos_x += $(this.vueInstance.$el).width();
		clone.data.clone_of = clone.data.id;
		clone.data.id = undefined;

		let parentNode;
		if (clone.data.child_of) {
			parentNode = this.drawflowInstance.getNodeFromId(
				clone.data.child_of,
				true,
			);
			parentNode.child_nodes[clone.id] = clone;
		}

		this._resetNestedNodes(clone);
		this.drawflowInstance.importNode(clone, this.drawflowInstance.module);
	}

	createModal() {
		pp.log(
			"Drawflow Helpers into create modal",
			this.vueInstance,
			this.vueInstance.dataNode.id,
			this.vueInstance.modalId,
		);
		if (this.vueInstance.modalId != "#replace-me") {
			return; // Nothing to do
		}

		const $modal = $(
			this.drawflowInstance.parent.modalsHtmlPerNodeType[
				this.vueInstance.dataNode.html
			],
		);
		const modalId = `${this.vueInstance.dataNode.id}-modal`;
		this.vueInstance.modalId = `#${modalId}`;
		$modal.attr("id", modalId);
		$modal.on("shown.bs.modal", () => {
			this._setSelectInModal($modal, this.vueInstance.dataNode);
			pp.global.initSelect2For($modal.find("select"));
			$modal.find("form").validate();
		});
		$modal.appendTo(this.drawflowInstance.container);
	}

	editNode() {
		pp.log("into editNode", this.vueInstance);
		const nodeId = this.vueInstance.dataNode.id;
		const node = this.drawflowInstance.getNodeFromId(nodeId);

		if (node.data.id) {
			this._loadEditForm();
		} else {
			pp.log("- saving first");
			this.vueInstance.dataNode.pendingLoadEditForm = true;
			DrawflowHelpers.saveToRails(this.drawflowInstance);
		}
	}

	removeNode() {
		pp.log("Drawflow Helpers into removeNode", this.vueInstance.dataNode);

		this.drawflowInstance.removeNodeId(this.vueInstance.dataNode.id);
	}

	addNodeToDrawflowData() {
		this.drawflowInstance.drawflow.drawflow[this.drawflowInstance.module].data[
			this.vueInstance.dataNode.id
		] = this.vueInstance.dataNode;
	}

	// Only draw connections from the input side
	redrawConnections() {
		// pp.log("into redrawConnections", this.vueInstance)
		Object.entries(this.vueInstance.dataNode.inputs).forEach(
			([input_item, input_array]) => {
				// pp.log("- at input item", input_item)
				input_array.connections.forEach((output_item) => {
					// pp.log("- at output", output_item);
					this.drawflowInstance.composeConnectionElem(
						output_item.input,
						input_item,
						output_item.node,
						this.vueInstance.dataNode.id,
						{ omit_updating_data: true },
					);
				});
			},
		);
		this.drawflowInstance.updateConnectionNodes(this.vueInstance.dataNode.id);
	}

	listenForModuleChange(ownModuleName) {
		this.drawflowInstance.on("beforeModuleChanged", (moduleName) => {
			if (moduleName == ownModuleName) {
				delete this.drawflowInstance.drawflow.drawflow[
					this.drawflowInstance.module
				].data[this.vueInstance.dataNode.id];
			}
		});
	}

	//-------------------------------------------------------------------------

	_loadEditForm() {
		// Need to reload
		pp.log("into loadEditForm", this);
		const nodeId = this.vueInstance.dataNode.id;
		const node = this.drawflowInstance.getNodeFromId(nodeId, true);
		node.pendingLoadEditForm = false; // In case this was set before
		$.ajax({
			url: `/${this.drawflowInstance.module}/${node.data.id}/show_drawflow`,
			type: "GET",
			dataType: "json",
			success: this._setupEditForm,
			error: () => {
				console.error("Could not load form for", node);
			},
		});
	}

	_setSelectInModal($modal, node) {
		pp.log(
			"Drawflow Helpers setSelectInModal",
			$modal,
			node,
			this.drawflowInstance,
		);
		const $select = $modal.find("select");
		$select.find("option").prop("disabled", false);
		// pp.log("into setSelectInModal",node, $select)
		Object.keys(node.child_nodes).forEach((childId, index) => {
			const childNode = this.drawflowInstance.getNodeFromId(childId, true);
			// pp.log("- at childNode", childNode);
			$select
				.find(
					`option[value='${childNode.data.actor_id || childNode.data.article_id}']`,
				)
				.prop("disabled", true);
		});

		// Select the "prompt" option and invoke select2 update
		// It is somehow not possible to make the "prompt" option be selected by default via the templates
		$select.find("option[value='']").prop("selected", true);
		$select.trigger("change");
	}

	_resetNestedNodes(parentNode) {
		pp.log("Drawflow Helpers into resetNestedNodes", parentNode);
		if (!parentNode.child_nodes) {
			return;
		}
		const newNodes = Object.values(parentNode.child_nodes).map((childClone) => {
			childClone.id = `m-${pp.viewHelpers.generateRandomId()}`;
			childClone.data.child_of = parentNode.id;
			childClone.data.id = undefined;
			Object.keys(childClone.inputs).forEach((inputType) => {
				childClone.inputs[inputType] = {
					connections: [],
					required: inputType == "req",
				};
			});
			Object.keys(childClone.outputs).forEach((outputType) => {
				childClone.outputs[outputType] = { connections: [] };
			});

			// pp.log("- cloned", childClone);
			this._resetNestedNodes(childClone); // Recur
			return childClone;
		});
		parentNode.child_nodes = {};
		newNodes.forEach((node) => {
			parentNode.child_nodes[node.id] = node;
		});
	}

	connectNode(connectionType) {
		// pp.log("into connectNode -- node id, node, connectionType, otherConnectionTypePlural", this.vueInstance.dataNode.id, this.vueInstance.dataNode, connectionType);
		Object.entries(this.vueInstance.dataNode[connectionType]).forEach(
			([connectionName, connectionsArray]) => {
				// pp.log(`- looking at connection -- connectionName, connectionsArray`, connectionName, connectionsArray);
				connectionsArray.connections.forEach((connectionItem) => {
					if (
						!this._connectToSingleNode(
							connectionType,
							connectionName,
							connectionItem,
						)
					) {
						pp.log(
							"- could not find otherNode",
							connectionItem.node,
							Object.keys(
								this.drawflowInstance.drawflow.drawflow[
									this.drawflowInstance.module
								].data,
							),
						);
					}
				});
			},
		);
		this.drawflowInstance.updateConnectionNodes(this.vueInstance.dataNode.id);
	}

	_connectToSingleNode(connectionType, connectionName, connectionItem) {
		// pp.log("-- at single connectionItem", connectionItem);
		const otherNode = this.drawflowInstance.getNodeFromId(
			connectionItem.node,
			true,
		);

		const ownConnectionTypeSting =
			connectionType == "inputs" ? "input" : "output";
		const otherConnectionTypePlural =
			connectionType == "inputs" ? "outputs" : "inputs"; // Inverse of the given param

		if (otherNode) {
			const otherNodeConnections =
				otherNode[otherConnectionTypePlural][
					connectionItem[ownConnectionTypeSting]
				].connections;
			// pp.log("-- got other node", otherNode.id, otherNode, otherNodeConnections);
			const presentConnectionEntry = otherNodeConnections.find(
				(foreignConnectionItem) => {
					return foreignConnectionItem.id == connectionItem.id;
				},
			);

			if (!presentConnectionEntry) {
				const newConnection = {
					id: connectionItem.id,
					node: this.vueInstance.dataNode.id,
				};
				newConnection[connectionType == "inputs" ? "output" : "input"] =
					connectionName;
				otherNodeConnections.push(newConnection);
			} else {
				// pp.log("- found presentConnectionEntry", presentConnectionEntry);
			}
			if (connectionType == "inputs") {
				this.drawflowInstance.composeConnectionElem(
					connectionItem[ownConnectionTypeSting],
					connectionName,
					connectionItem.node,
					this.vueInstance.dataNode.id,
					{ omit_updating_data: true },
				);
			} else {
				this.drawflowInstance.composeConnectionElem(
					connectionName,
					connectionItem[ownConnectionTypeSting],
					this.vueInstance.dataNode.id,
					connectionItem.node,
					{ omit_updating_data: true },
				);
			}
			return true;
		}
		return false;
	}

	_setupEditForm(json, status, request) {
		// pp.log("into setupEditForm -- json, status, request", json, status, request);
		$("#shell-modal .modal-body").html(json.html);
		$("#shell-modal").one("shown.bs.modal", () => {
			$(document).trigger("page:change");
		});
		$("#shell-modal")
			.addClass("modal--wide modal--with-max-height")
			.modal("show");
		$("#shell-modal").one("hide.bs.modal", () => {
			$("#shell-modal .modal-body").html("");
			$("#shell-modal").removeClass("modal--wide modal--with-max-height");
		});
	}

	_nodeRemoved() {
		const node = this.vueInstance.dataNode;
		pp.log("Drawflow Helpers into nodeRemoved", node.id);
		if (node.child_nodes) {
			Object.keys(node.child_nodes).forEach((childNodeId) => {
				// Will recur to calling this method `removeNode` again via event dispatch
				pp.log("- recursion: removing child", childNodeId);
				this.drawflowInstance.removeNodeId(childNodeId); // Need to cast back to prefix
			});
		}
		if (node.data.child_of) {
			const parentNode = this.drawflowInstance.getNodeFromId(
				node.data.child_of,
				true,
			);
			// pp.log("- is child of", node.data.child_of, parentNode, $(`#${node.data.child_of}`));
			delete parentNode.child_nodes[node.id];
		}
		if (this.drawflowInstance.markNodesAsDeletedOnRemove && node.data.id) {
			this.drawflowInstance.deletedNodes[node.html] =
				this.drawflowInstance.deletedNodes[node.html] || {};
			this.drawflowInstance.deletedNodes[node.html][`${node.data.id}`] =
				Object.assign(
					{},
					this.drawflowInstance.deletedNodes[node.html][`${node.data.id}`],
					{ parent_node: node.data.child_of },
				);
		}
	}
}
